/** Functionality to manipulate photos on the client side */

export default class PhotoManipulator {
    constructor(srcImg) {
        this.output = {
            quality: 1,
            height: srcImg.height,
            width: srcImg.width,
        };

        this.srcImg = srcImg;
    }

    setMaxSize(maxLongestSide) {
        maxLongestSide = maxLongestSide || 1024;

        const { height, width } = this.srcImg;

        if (height > width) {
            if (height > maxLongestSide) {
                this.output.height = maxLongestSide;
                this.output.width = width * (maxLongestSide / height);
            }
        } else if (width > maxLongestSide) {
            this.output.height = height * (maxLongestSide / width);
            this.output.width = maxLongestSide;
        }

        return this;
    }

    /** Set quality of output jpg
     *
     * @param quality - quality of jpg decimal btwn 0 - 1;
     */
    setQuality(quality) {
        if (quality <= 0 || quality > 1) {
            throw new Error('Jpg quality must be a decimal between 0 - 1');
        }
        this.output.quality = quality;
        return this;
    }

    /** Draws to an existing canvas element
     *
     * @param canvas if no canvas given, creates a new one
     * @returns {*|Element} canvas element in param or new canvas element if no param provided
     */
    drawToCanvas(canvas) {
        canvas = canvas || document.createElement('canvas');
        const { output } = this;
        canvas.width = output.width;
        canvas.height = output.height;
        canvas
            .getContext('2d')
            .drawImage(this.srcImg, 0, 0, output.width, output.height);
        return canvas;
    }

    /** Gets the transformed image encoded as a Data URL
     *
     * @param drawnCanvas provide drawn canvas if you already ran drawToCanvas to save a few steps
     * @returns {string}
     */
    getDataURL(drawnCanvas) {
        const canvas = drawnCanvas || this.drawToCanvas();
        return canvas.toDataURL('image/jpeg', +this.output.quality);
    }

    /** Gets the transformed image as an image elem. Note original image is not affected */
    getImg() {
        const renderedImg = new Image();
        renderedImg.src = this.getDataURL();
        return renderedImg;
    }
}
